import { useContext } from 'react';
import OnboardingContext , { OnboardingState } from './Context';

const useOnboardingContext = (): OnboardingState => useContext(OnboardingContext);

export default useOnboardingContext;
